import { render, staticRenderFns } from "./DateValue.vue?vue&type=template&id=56af5ac1&lang=pug&"
import script from "./DateValue.vue?vue&type=script&lang=ts&"
export * from "./DateValue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports